export default __webpack_public_path__ + "static/media/banner1.7fc4458e.jpg";